import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './MortgageCalculatorSection.css';

interface IMortgageCalculatorSectionProps {
  title: React.ReactNode;
  calculator: React.ReactNode;
}

export function MortgageCalculatorSection({ title, calculator }: IMortgageCalculatorSectionProps) {
  return (
    <section id="mortgage" className={styles['container']}>
      <Layout>
        <div className={styles['title']}>{title}</div>

        {calculator}
      </Layout>
    </section>
  );
}
